/* eslint-disable import/prefer-default-export */
import React from "react";
import { Book, Building, FingerCricle, Health, People } from "iconsax-react";

import type { MapPoiCategory } from "../services/map.types";

const ICON_SIZE = 20;

export function CategoryIcon({
  category,
  size = ICON_SIZE,
  color = "currentColor",
  variant = "Outline",
}: {
  category: MapPoiCategory;
  size?: number;
  color?: string;
  variant?: "Bold" | "Outline";
}) {
  const props = { size, color, variant };

  switch (category) {
    case "saude":
      return <Health {...props} />;
    case "educacao":
      return <Book {...props} />;
    case "escola_publica":
      return <Building {...props} />;
    case "comunidade":
      return <People {...props} />;
    case "acessibilidade":
      return <FingerCricle {...props} />;
    default:
      return <Book {...props} />;
  }
}
